module.exports = __webpack_public_path__ + "img/feedback.50640221.png";